import { render } from "./ClientConfiguracionUsuarios.vue?vue&type=template&id=a6af7732&scoped=true"
import script from "./ClientConfiguracionUsuarios.vue?vue&type=script&lang=js"
export * from "./ClientConfiguracionUsuarios.vue?vue&type=script&lang=js"

import "./ClientConfiguracionUsuarios.vue?vue&type=style&index=0&id=a6af7732&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6af7732"]])

export default __exports__